var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-content"},[_c('intro',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getStartedState),expression:"!getStartedState"}]}),_vm._v(" "),_c('question',{directives:[{name:"show",rawName:"v-show",value:(_vm.getStartedState),expression:"getStartedState"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328c2c2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 51
// module chunks = 0